import * as React from 'react'

import { styled } from '~/styled'

import { Loader } from '../loader/Loader'
import { AsyncDataState } from './DataTable.types'
import { useDataTable } from './DataTableContext'

const PendingState = styled(Loader, {
  base: [
    'absolute',
    'left-1/2',
    'top-1/2',
    '-translate-x-1/2',
    '-translate-y-1/2',
    'z-1'
  ]
})

export const DataTableLoading = (
  props: React.ComponentProps<typeof PendingState>
) => {
  const { asyncDataState } = useDataTable()

  if (asyncDataState !== AsyncDataState.PENDING) return null

  return <PendingState {...props} />
}
